<template>

  <v-autocomplete v-model="regionID"
                  label="Region"
                  :placeholder="placeholder"
                  :items="regions"
                  item-text="name"
                  item-value="id"
                  :clearable="true"
                  :loading="loading"
                  :disabled="isDisabled"
                  hide-no-data="hide-no-data"></v-autocomplete>

</template>

<script>

export default {
  name: 'RegionSelector',
  props: ['federationID', 'currentRegionID'],
  data () {
    return {
      loading: false,
      regions: [],
      regionID: ''
    }
  },
  mounted () {
    if (this.federationID) {
      this.loadRegions()
    }

    if (this.currentRegionID) {
      this.regionID = this.currentRegionID
    }
  },
  methods: {
    loadRegions () {
      if (!this.currentRegionID) {
        this.$emit('regionSelected', '')
      }

      if (this.federationID) {
        this.loading = true
        this.$store.dispatch('getFederationRegions', this.federationID)
          .then(resp => {
            let regions = [resp]
            this.sortRegions(regions)
            this.loading = false
          })
          .catch(() => {
            console.error('Error loading regions')
            this.loading = false
          })
      } else {
        this.regionID = ''
        this.regions = []
      }
    },
    sortRegions (regions) {
      for (let region of regions) {
        this.addRegionToSorting(region)
      }
    },
    addRegionToSorting (region) {
      this.regions.push(region)
      if (region.subregions.length !== 0) {
        for (let subregion of region.subregions) {
          this.addRegionToSorting(subregion)
        }
      }
    }
  },
  computed: {
    isDisabled () {
      return this.regions.length === 0
    },
    placeholder () {
      return this.isDisabled ? 'Please select a federation first' : 'Region'
    }
  },
  watch: {
    'federationID' () {
      this.loadRegions()
    },
    'regionID' () {
      this.$emit('regionSelected', this.regionID || '')
    },
    'currentRegionID' () {
      if (this.currentRegionID) {
        this.regionID = this.currentRegionID
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/RegionSelector.vue